import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseService } from './baseservice';

type SavePayloadVariant = {
  body: any;
  options: { headers: HttpHeaders };
};

@Injectable({
  providedIn: 'root'
})
export class OrganizationColorsService extends BaseService {
  private readonly getAppColorsEndpoint = '/api/orgs/current/appcolors';
  private readonly saveAppColorsEndpoints = [
    '/api/orgs/current/appcolors',
    '/api/orgs/appcolors'
  ] as const;
  private readonly textPlainOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'text/plain' })
  };

  constructor(private http: HttpClient) {
    super();
  }

  getAppColors(): Observable<any> {
    return this.http.get(this.rootUrl + this.getAppColorsEndpoint, this.httpOptions);
  }

  saveAppColors(appColorsJson: string): Observable<any> {
    const wrappedPayload = {
      AppColors: appColorsJson,
      appColors: appColorsJson,
    };

    let parsedPalette: any = null;
    try {
      parsedPalette = JSON.parse(appColorsJson);
    } catch {
      parsedPalette = null;
    }

    const payloadVariants: SavePayloadVariant[] = [
      { body: appColorsJson, options: this.textPlainOptions },
      { body: wrappedPayload, options: this.httpOptions },
    ];

    if (parsedPalette) {
      payloadVariants.push({ body: parsedPalette, options: this.httpOptions });
    }

    return this.trySaveAppColors(0, 0, payloadVariants);
  }

  private trySaveAppColors(endpointIndex: number, payloadIndex: number, payloadVariants: SavePayloadVariant[]): Observable<any> {
    if (endpointIndex >= this.saveAppColorsEndpoints.length) {
      return throwError(() => new Error('Unable to save app colors.'));
    }

    if (payloadIndex >= payloadVariants.length) {
      return this.trySaveAppColors(endpointIndex + 1, 0, payloadVariants);
    }

    const payloadVariant = payloadVariants[payloadIndex];
    const url = this.rootUrl + this.saveAppColorsEndpoints[endpointIndex];

    return this.http.put(url, payloadVariant.body, payloadVariant.options).pipe(
      catchError(() => this.http.post(url, payloadVariant.body, payloadVariant.options).pipe(
        catchError((error) => {
          return this.trySaveAppColors(endpointIndex, payloadIndex + 1, payloadVariants).pipe(
            catchError(() => throwError(() => error))
          );
        })
      ))
    );
  }
}
